import {SliderState} from '@react-ui-stately/slider';

export const sliderIds = new WeakMap<SliderState, string>();
